import React, { useState, useContext, useEffect } from "react"
import { Layer, Source } from "react-map-gl/mapbox";
import 'mapbox-gl/dist/mapbox-gl.css';
import MapPopup from "layouts/station/mapPopup.tsx"
import { StationContext } from "pages/StationsPage.tsx"
import { StationGeojson } from "types/stations"
import { GeoJSON } from "geojson"
import { LayerProps } from "react-map-gl/mapbox-legacy"

interface MarkerProps {
    geojson: StationGeojson | undefined
}

const MapMarkers: React.FC<MarkerProps> = ({ geojson }) => {
    const stationContext = useContext(StationContext)
    const [chosenStation, setChosenStation] = useState<
        StationGeojson["features"][0] | undefined
    >(undefined)

    const stationAvailableLayer = {
        id: "station_available_layer",
        type: "symbol",
        source: "stations_source",
        filter: ["==", ["get", "status"], "available"],
        layout: {
            "icon-image": "station_available",
            "icon-allow-overlap": true,
            "icon-size": 1,
        },
    }

    const stationClosedLayer = {
        id: "station_closed_layer",
        type: "symbol",
        source: "stations_source",
        filter: ["==", ["get", "status"], "unavailable"],
        layout: {
            "icon-image": "station_closed",
            "icon-allow-overlap": true,
            "icon-size": 1,
        },
    }

    useEffect(() => {
        if (stationContext) {
            setChosenStation(stationContext)
        }
    }, [stationContext])

    return (
        <>
            <Source id="stations_source" type="geojson" data={geojson as GeoJSON}>
                <Layer {...stationAvailableLayer as LayerProps} />
                <Layer {...stationClosedLayer as LayerProps} />
            </Source>

            {chosenStation && <MapPopup chosenStation={chosenStation} />}
        </>
    )
}

export default MapMarkers
